import { render } from "./reprintArticle.vue?vue&type=template&id=7e71c652"
import script from "./reprintArticle.vue?vue&type=script&lang=js"
export * from "./reprintArticle.vue?vue&type=script&lang=js"

import "./reprintArticle.vue?vue&type=style&index=0&id=7e71c652&lang=scss"

import exportComponent from "F:\\webStorm workspace\\ujk_tangying\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__